const actions = [
  {
      title: 'Look up information from reliable sources',
      text: 'Go to reputable sources to find out more about the health consequences related to your lifestyle change. NHS and LiveWell Dorset are good places to start as they have lots of useful articles on their websites.',
  },
  {
      title: 'Check the guidelines',
      text: 'Look up health guidelines to find out what\'s recommended for you. The NHS website has information on alcohol units, healthy weight, physical activity and quitting smoking. For example, the guidelines recommend drinking no more than 14 units of alcohol a week.',
  },
  {
      title: 'Find out the benefits',
      text: 'Making lifestyle changes to improve your health can lead to benefits for your body, your mind and your wallet. Find out more about the advantages of adopting new, healthier habits by looking at LiveWell Dorset\'s website and other reputable sources such as the NHS and Drinkaware.',
  },
  {
      title: 'Get support',
      text: 'There\'s lots of help available if you need more support. Reach out to LiveWell Dorset and we can point you in the right direction or you can find local services on the NHS website.',
  },
];

const tip = 'Knowledge is power. Find out more about the consequences of unhealthy habits and the benefits of making lifestyle changes by going to trusted sources such as LiveWell Dorset or the NHS for more information.';

// eslint-disable-next-line import/no-anonymous-default-export
export default { actions, tip };
